import type { PaginationCap, PaginationOptions, WalkedPage } from '../types';

// gloss
export const collectPages = async <T, O extends PaginationOptions<never>>(
  iterate: (options: O) => AsyncIterable<WalkedPage<T>>,
  options: O,
): Promise<T[]> => {
  let cap: PaginationCap | undefined;
  const items: T[] = [];
  const pages = iterate({
    ...options,
    onCapped: (reported) => {
      cap = reported;
    },
  });
  for await (const walked of pages) items.push(...walked.items);

  const maxRows = options.maxRows ?? Number.POSITIVE_INFINITY;
  if (items.length > maxRows) {
    items.length = maxRows;
    cap = { reason: 'maxRows', returned: maxRows };
  }
  if (cap) options.onCapped?.({ reason: cap.reason, returned: items.length });
  return items;
};
